export default function(target) {
  for (let i = 1, j = arguments.length; i < j; i++) {
    let source = arguments[i] || {};
    for (let prop in source) {
      if (source.hasOwnProperty(prop)) {
        let value = source[prop];
        if (value !== undefined) {
          target[prop] = value;
        }
      }
    }
  }

  return target;
};



//////////////////
// WEBPACK FOOTER
// ./~/.1.4.12@element-ui/src/utils/merge.js
// module id = 14
// module chunks = 0